import { render, staticRenderFns } from "./InstancePanel.vue?vue&type=template&id=415f7f9c&scoped=true&"
import script from "./InstancePanel.vue?vue&type=script&lang=js&"
export * from "./InstancePanel.vue?vue&type=script&lang=js&"
import style0 from "./InstancePanel.vue?vue&type=style&index=0&id=415f7f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f7f9c",
  null
  
)

export default component.exports